export interface DecisionReportIntersectionPoint {
  coord: [number, number];
}

/**
 * 按 X 轴顺序查找两条折线的所有相交点。
 *
 * 当相交发生在两个采样点之间时，使用线性插值计算坐标，避免固定取某
 * 个月份导致标记偏离真实相交位置。返回值按 X 轴顺序排列，未相交时返回空数组。
 */
export function getLineIntersectionPoints(
  firstSeriesData: number[],
  secondSeriesData: number[],
): DecisionReportIntersectionPoint[] {
  const dataLength = Math.min(firstSeriesData.length, secondSeriesData.length);
  const epsilon = 1e-8;
  const intersections: DecisionReportIntersectionPoint[] = [];

  for (let index = 0; index < dataLength; index++) {
    const currentFirstValue = firstSeriesData[index];
    const currentSecondValue = secondSeriesData[index];
    const currentDifference = currentFirstValue - currentSecondValue;

    if (Math.abs(currentDifference) <= epsilon) {
      const previousIntersection = intersections[intersections.length - 1];
      if (!previousIntersection || previousIntersection.coord[0] !== index) {
        intersections.push({ coord: [index, currentFirstValue] });
      }
      continue;
    }

    if (index === dataLength - 1) {
      continue;
    }

    const nextFirstValue = firstSeriesData[index + 1];
    const nextSecondValue = secondSeriesData[index + 1];
    const nextDifference = nextFirstValue - nextSecondValue;

    if (currentDifference * nextDifference < 0) {
      const ratio = currentDifference / (currentDifference - nextDifference);
      const intersectionX = index + ratio;
      const intersectionY = currentFirstValue + (nextFirstValue - currentFirstValue) * ratio;
      intersections.push({ coord: [intersectionX, intersectionY] });
    }
  }

  return intersections;
}

export function getDecisionReportMetricGrid() {
  return [
    { key: 'dailyCaptureRate', color: '#FFAF55', title: '区域捕获率' },
    { key: 'dailyEntryFlow', color: '#57C6E5', title: '日均进店客流' },
    { key: 'dailyPerformance', color: '#6268D9', title: '日均业绩' },
  ];
}
